<template>
    <div class="form-more-wrapper">
        <Button :text="addLabel" :icon="addIcon" :hoverIcon="addIconHover" @btnClick="addClick" />
        <div class="sel-form-type" v-show="isShowWidget">
            <ul class="form-type-tab">
                <li v-for="(widget, index) in widgets" :key="index" @click="widgetSelect(widget.wtType)">{{ widget.text }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import Button from "@/views/zhiji/bComponents/buttons/Button";

export default {
    name: "FormMore",
    props: ["isShowDefault"],
    components: {
        Button
    },
    data() {
        return {
            isShowWidget: false,
            addIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px 0",
            addIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px -22px",
            widgets: getWidgets(this)
        };
    },
    computed: {
        addLabel() {
            return this.$t("zhiji.form.pleaseAddForm");
        },
        isShowRoleMessage() {
            return this.isShowDefault;
        }
    },
    watch: {
        isShowRoleMessage: {
            handler(newValue) {
                if (newValue) {
                    this.widgetSelect("RoleMessage");
                }
            },
            immediate: true
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.formEdit[propName];
        },
        addClick() {
            this.isShowWidget = true;
        },
        widgetSelect(wtType) {
            this.$store.commit("zhiji/editFormContents", {
                type: "addFormContent",
                wtType: wtType
            });
            this.isShowWidget = false;

            this.$emit("widgetSelect");
        }
    },
    mounted() {
        this.widgetSelect("RoleMessage");
    }
};

function getWidgets(vue) {
    return [
        {
            wtType: "Options",
            text: vue.$t("zhiji.form.options.name")
        },
        {
            wtType: "SingleText",
            text: vue.$t("zhiji.form.singleText.name")
        },
        {
            wtType: "MultilineText",
            text: vue.$t("zhiji.form.multilineText.name")
        },
        {
            wtType: "UpPicture",
            text: vue.$t("zhiji.form.upPicture.name")
        },
        {
            wtType: "Time",
            text: vue.$t("zhiji.form.time.name")
        },
        {
            wtType: "RoleMessage",
            text: vue.$t("zhiji.form.roleMessage.name")
        }
    ];
}
</script>

<style lang="scss" scoped>
.form-more-wrapper {
    margin: 16px;
    font-size: 12px;

    .sel-form-type {
        width: 594px;
        padding: 16px 16px 8px 16px;
        margin-top: 8px;
        background: #ffffff;
        border: 1px solid #d9e4ef;
        box-shadow: 0px 0px 8px 0px rgba(90, 98, 111, 0.25);
        border-radius: 4px;
        z-index: 1;

        .form-type-tab {
            border-radius: 4px;
            color: #41475e;
            cursor: pointer;
            display: flex;
            flex-wrap: wrap;
        }

        li {
            display: inline-flex;
            padding: 4px 15px 5px;
            margin-bottom: 8px;
            color: #41475e;
            border-radius: 4px;
            border-style: solid;
            border-width: 1px;
            margin-right: 8px;
            border-color: #d8e4f0;
            cursor: pointer;
            &:last-child {
                margin-right: 0;
            }
            &.on,
            &:hover {
                background: #4cadf2;
                color: #fff;
                border-color: #d8e4f0;
            }
        }
    }
}
</style>
